import { Navigate, Outlet } from 'react-router-dom';
import React from 'react';
import Cookies from 'js-cookie';

const ProtectedRouteSetupAdmin = ({ allowedRole, redirectTo }) => {
  // let role = sessionStorage.getItem('role');
  let role = Cookies.get('role');
  // If the role is not allowed, redirect to the specified route
  if (role !== allowedRole) {
    return <Navigate to={redirectTo} />;
  }
  // Otherwise, render children routes
  return <Outlet />;
};

export default ProtectedRouteSetupAdmin;
